@if (matFormField) {
    <div [formGroup]="form" class="row">
        @if (!hideDate) {
            <mat-form-field [appearance]="appearance" class="{{hideDate ? 'col' : 'col-7'}}">
                <mat-label>{{labelDate}}</mat-label>
                <input
                    (click)="picker.open()"
                    [formControl]="fcDate"
                    [matDatepicker]="picker"
                    [max]="max"
                    [min]="min"
                    matInput
                    placeholder="{{labelDate}}">
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        }
        <mat-form-field [appearance]="appearance" class="{{hideDate ? 'col' : 'col-5'}}">
            <mat-label>{{labelTime}}</mat-label>
            <input
                #timeInput
                (click)="timeInput.select()"
                [formControl]="fcTime"
                matInput
                placeholder="hh:mm"
                type="text">
        </mat-form-field>
    </div>
} @else if (!matFormField) {
    <div [formGroup]="form" class="d-flex" role="group">
        @if (!hideDate) {
            <input
                (click)="picker.open()"
                [formControl]="fcDate"
                [matDatepicker]="picker"
                [max]="max"
                [min]="min"
                class="col-7"
                matInput
                placeholder="{{labelDate}}">
        }
        <mat-datepicker #picker></mat-datepicker>
        <input
            #timeInput
            (click)="timeInput.select()"
            [formControl]="fcTime"
            class="{{timeClass ?? (hideDate ? 'col-12' : 'col-5')}}"
            matInput
            placeholder="hh:mm"
            type="text">
    </div>
}
